import template from './loansRepaymentSimulate.html';
import controller from './loansRepaymentSimulate.controller';
import './loansRepaymentSimulate.scss';

let loansRepaymentSimulateComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    loansSimulation: '<',
    repaymentParcial: '&',
    isMobileApp: '<',
  },
  template,
  controller
};

export default loansRepaymentSimulateComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepaymentSimulate/loansRepaymentSimulate.component.js